import angular from 'angular';
import { EventsRepAssignmentContainerComponent } from './events-rep-assignment-container.component';

export const EventsRepAssignmentModule = angular
    .module("apex.mainApp.eventsScheduling.eventRepAssignment", [])
    .component("apexEventsRepAssignmentContainer", EventsRepAssignmentContainerComponent)
    .name;
